<template>
<div class="vx-row mb-4" v-if="countData">
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 mb-2">
        <vx-card class="shadow-none grey_border_card">
            <div slot="no-body">
                <vs-row>
                    <vs-col vs-w="12" class="p-3 md:p-5">
                        <div class="flex justify-between">
                            <vs-icon size="medium" icon="group_add" color="#587BE9" />
                            <h4 class="md:text-xl lg:text-3xl xl:text-5xl font-bold mb-2 blue_text custom-margin-top">{{ countData.totalCount }}</h4>
                        </div>
                        <p class="text-sm">Total Count</p>
                    </vs-col>
                </vs-row>
            </div>
        </vx-card>
    </div>
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 mb-2">
        <vx-card class="shadow-none grey_border_card">
            <div slot="no-body">
                <vs-row>
                    <vs-col vs-w="12" class="p-3 md:p-5">
                        <div class="flex justify-between">
                            <vs-icon size="medium" icon="login" color="#1E9D6F" />
                            <h4 class="md:text-xl lg:text-3xl xl:text-5xl font-bold mb-2 green_text custom-margin-top">{{ countData.signedInCount }}</h4>
                        </div>
                        <p class="text-sm">Signed In</p>
                    </vs-col>
                </vs-row>
            </div>
        </vx-card>
    </div>
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 mb-2">
        <vx-card class="shadow-none grey_border_card">
            <div slot="no-body">
                <vs-row>
                    <vs-col vs-w="12" class="p-3 md:p-5">
                        <div class="flex justify-between">
                            <vs-icon size="medium" icon="do_not_disturb" color="#e65a71" />
                            <h4 class="md:text-xl lg:text-3xl xl:text-5xl font-bold mb-2 red_text custom-margin-top">{{ countData.deniedCount }}</h4>
                        </div>
                        <p class="text-sm">Denied</p>
                    </vs-col>
                </vs-row>
            </div>
        </vx-card>
    </div>
</div>
</template>

<script>
import {
    visitHistoryData
} from '@/store/api/visitHistory.js';

export default {

    props: {
        propCurrentFilter: {
            type: Object,
            required: true,
        },
        propKey: {
            type: Number,
            required: true
        }
    },
    watch: {
        propCurrentFilter: {
            immediate: true,
            deep: true,
            async handler(newValue, oldValue) {
                if (newValue !== undefined) {
                    this.currentFilter = newValue;
                }
            }
        },
        propKey: {
            immediate: true,
            deep: true,
            async handler(newValue, oldValue) {
                if (newValue !== undefined) {
                    await this.loadCounts();
                }

            }
        }
    },

    data() {
        return {
            startDate: '',
            endDate: '',
            countData: undefined,
            rangeType: '',
            currentFilter: undefined
        }
    },
    methods: {
        async loadCounts() {
            var payload = {
                startDate: this.currentFilter.date[0],
                endDate: this.currentFilter.date[1],
                rangeType: this.currentFilter.rangeType
            }
            this.countData = await visitHistoryData.searchVisitHistoryCount(payload);
        },
    }
}
</script>

<style scoped>
.custom-margin-top {
    margin-top: -8px;
}
</style>
